/**
 * ## Init Startup extras for development
 *
 * @module src/controllers/init
 */

"use strict";

let kd;

/**
 */
const init = (kdObj) => {
  kd = kdObj;
};

module.exports = {
  init,
};



/** WEBPACK FOOTER **
 ** ./src/controllers/init/index.js
 **/